import { z } from 'zod';

import { allCountryCodes, unsupportedCountryCodes } from '@Common/countries';

export const ZodCountryCode = z.enum([allCountryCodes[0], ...allCountryCodes], {
  error: 'Invalid country code',
});

export type CountryCode = z.infer<typeof ZodCountryCode>;

/**
 * Every code the `countries` table can hold: the ones we have country data for, plus the ones the apps do not support.
 */
export const ZodStoredCountryCode = z.enum(
  [allCountryCodes[0], ...allCountryCodes, ...unsupportedCountryCodes],
  { error: 'Invalid country code' },
);

export type StoredCountryCode = z.infer<typeof ZodStoredCountryCode>;

export const ZodInstrumentCountryCode = z.enum([
  allCountryCodes[0],
  ...allCountryCodes,
  ...unsupportedCountryCodes,
]);
